import SummerCampPaymentCheckout from ".";
import { NewUserContextProvider } from "../../../APIContext/NewUserContext";
import { SummerCampProvider } from "../../../APIContext/summerCampContext";

const summerCampCheckoutWrapper = () => {
  return (
    <>
      <SummerCampProvider>
        <NewUserContextProvider>
          <SummerCampPaymentCheckout />
        </NewUserContextProvider>
      </SummerCampProvider>
    </>
  );
};

export default summerCampCheckoutWrapper;
